// export const BASE_URL = "http://localhost:8080";
export const BASE_URL = "https://memes-share-backend.onrender.com";
